import {applySpec, get} from '@yandex-delivery/utils'

import type {NddClaimSourcePoint, SourcePoint} from 'src/shared/types'
import {SourcePointDeliveryMethod} from 'src/shared/types'

const fromStation: (point?: SourcePoint) => NddClaimSourcePoint = applySpec<NddClaimSourcePoint>({
  platform_station: {
    platform_id: get('station.station_id'),
  },
})

const fromDropOffPoint: (point?: SourcePoint) => NddClaimSourcePoint = applySpec<NddClaimSourcePoint>({
  platform_station: {
    platform_id: get('dropOffPoint.point.id'),
  },
})

export function fromNddSourcePoint(point?: SourcePoint): NddClaimSourcePoint {
  const deliveryMethod = get('_deliveryMethod', point)

  switch (deliveryMethod) {
    case SourcePointDeliveryMethod.Station:
      return fromStation(point)
    case SourcePointDeliveryMethod.DropOffPoint:
      return fromDropOffPoint(point)
    default:
      throw new Error(`Unknown source point delivery method: ${deliveryMethod}`)
  }
}
